



































































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { IValorFaixaPreco, FaixaDePrecoDTO} from "@/models/orcamento-auto-online/FaixaPrecoConcerto";
import { orcamentoAutoOnlineService } from "@/service/orcamento-auto-online/OrcamentoAutoOnlineService";
import { ValidationObserver } from "vee-validate";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class FaixaDePreco extends Vue {
  @Ref()
  filtroObserver!: InstanceType<typeof ValidationObserver>;

  valores: FaixaDePrecoDTO[] = [];
  loading = false;
  cabecalho = [
      { text: "Valor Inicial", value: "valorInicial", width: "20%" },
      { text: "Valor Final", value: "valorFinal", width: "20%" },
      { text: "Percentual", value: "percentual", width: "20%" },
      { text: "Ações", value: "actions", width: "15%", sortable: false }
  ];
  salvarFaixa: FaixaDePrecoDTO = {
    id: 0,
    valorInicial: 0,
    valorFinal: 0,
    percentual: 0
  };
  valorFaixaPreco: IValorFaixaPreco = { 
    id: 0, 
    valorInicial: undefined,
    valorFinal: undefined,
    percentual: undefined
  };

  dialogType = "sucess";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  alterarConfiguracao(IValorFaixaPreco: IValorFaixaPreco) {
    this.valorFaixaPreco = Object.assign({}, IValorFaixaPreco);
  }

  beforeMount() {
    this.obterFaixaDePreco();
  }

  obterFaixaDePreco() {
    this.loading = true;
    this.valores = [];
    orcamentoAutoOnlineService
    .obterFaixaPrecoConcerto(
      ).then((res: FaixaDePrecoDTO[]) => {
          this.valores = res;
          this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  salvarFaixaDePreco() {
    let valid = true;  
   
    if (!this.valorFaixaPreco.valorInicial) {
      this.filtroObserver.setErrors({
        ValorInicial: "O campo Valor Inicial é obrigatório",
      });
      valid = false;
    }
    if (!this.valorFaixaPreco.valorFinal) {
      this.filtroObserver.setErrors({
        ValorFinal: "O campo Valor Final é obrigatório",
      });
      valid = false;
    }
    if (!this.valorFaixaPreco.percentual) {
      this.filtroObserver.setErrors({
        Percentual: "O campo Percentual é obrigatório",
      });
      valid = false;
    }
    if(!valid) { 
      return;
    }  
      
    this.salvarFaixa.id = this.valorFaixaPreco.id;
    this.salvarFaixa.valorInicial = this.valorFaixaPreco.valorInicial;
    this.salvarFaixa.valorFinal = this.valorFaixaPreco.valorFinal;
    this.salvarFaixa.percentual = this.valorFaixaPreco.percentual;

    orcamentoAutoOnlineService
    .salvarFaixaPrecoConcerto(
    this.salvarFaixa
    ).then(() => {
    this.resetValorFaixaConcerto()
    this.openDialog('success', "Alteração realizada com sucesso", "Alteração realizada com sucesso");
    })
    .catch((err: any) => {
        console.log(err);
        this.openDialog('error', 'Erro ao realizar a inclusão da faixa.', err.message);
    });
}

  resetValorFaixaConcerto() {
    this.valorFaixaPreco.id = 0;
    this.valorFaixaPreco.valorInicial = undefined;
    this.valorFaixaPreco.valorFinal = undefined;
    this.valorFaixaPreco.percentual = undefined;
    this.obterFaixaDePreco();
  }

  realizarExclusao(FaixaPreco: IValorFaixaPreco) {
    orcamentoAutoOnlineService.excluirFaixaPrecoConcerto(FaixaPreco.id)
    .then(() => {
      this.obterFaixaDePreco();  
      this.openDialog('success', "Exclusão da faixa efetuada com sucesso.", "Exclusão da faixa efetuada com sucesso.");
    })
    .catch(() => {
       this.openDialog('error', 'Erro ao realizar a exclusão da faixa.', 'Erro ao realizar a exclusão da faixa.');
    })
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }
}
